import styled from "@emotion/styled"
import { PaperProps, Backdrop } from "@material-ui/core"
import MuiDialogActions from "@material-ui/core/DialogActions"
import Icon from "@material-ui/core/Icon"
import Paper from "@material-ui/core/Paper/Paper"
import IconButton from "components/IconButton"
import { docketTheme } from "theme"
import { MuiDialog, TDialogWidthClassKey } from "theme/Dialog"
import { capitalizeWord } from "utils"
import { IDialogProps } from "./types"

interface IDialogBody {
  height: IDialogProps["contentHeight"]
}

type TDialogPaperWidth = Pick<IDialogProps, "width">
type TStyledDialogPaper = PaperProps & TDialogPaperWidth

export const DialogSection = styled.div`
  padding: ${({ theme }) => theme.spacing(3)};
`

export const DialogHeader = styled(DialogSection)`
  display: flex;
`

export const DialogHeaderContent = styled.div`
  display: flex;
  align-items: flex-start;
  flex: 1;
  align-self: center;
  flex-wrap: wrap;

  svg {
    margin-right: ${({ theme }) => theme.spacing(1)};
  }
`

export const DialogCaption = styled.div`
  color: ${docketTheme.colors.grey[60]};
  &:not(:first-child) {
    margin-top: ${({ theme }) => theme.spacing()};
    flex-basis: 100%;
  }
`

export const DialogCloseButton = styled(IconButton)`
  align-self: flex-start;
  margin-left: ${({ theme }) => theme.spacing()};
  margin-right: -3px;
  margin-top: -3px;
`

export const DialogCloseIcon = styled(Icon)`
  font-size: 3.2rem;
  color: ${({ theme }) => theme.palette.text.primary};
` as typeof Icon

export const DialogBody = styled(DialogSection)<IDialogBody>`
  padding-top: 0;
  flex: 1;
  min-height: 0;
  overflow: auto;
  display: flex;
  flex-direction: column;
  ${({ height }) => height && `flex: 0 1 ${height}rem`};
`

export const DialogActions = styled(MuiDialogActions)`
  padding: ${({ theme }) => `${theme.spacing(2)} ${theme.spacing(3)}`};
  background: ${docketTheme.colors.grey[95]};
`

export const StyledDialogPaper = styled(Paper)<TStyledDialogPaper>`
  min-width: 0; // max-width fix. Do not remove.
  width: ${({ width }) =>
    width ? MuiDialog[`paperWidth${capitalizeWord(width)}` as TDialogWidthClassKey].maxWidth : "auto"};
  ${({ width }) => width && "max-width: 100vw"};
`

export const StyledBackdrop = styled(Backdrop)`
  position: absolute;
  z-index: 1;
  background-color: rgba(255, 255, 255, 0.5);
`
